<template>
    <div class="more-block">
        <h2 class="title" v-html="title">
        </h2>
        <p v-html="content">
        </p>
        <router-link :to="linkURL" class="small_title">
            MORE
        </router-link>
    </div>
</template>

<script>
export default {
    name: "MoreBlock",
    props: {
        title: String,
        content: String,
        linkURL: {
            type: String,
            default: '/'
        },
    }

}
</script>

<style lang="scss" scoped>
.more-block{
    margin: 103px 70px 0;
    padding-bottom: 103px;
    text-align: center;
    border-bottom: 1px solid #d9d9d9;
}

@media (max-width: $mobile) { 
    .more-block{
        margin: 1rem auto;
        padding: 1rem 5%;
    }
    .small_title{
        display: block;
        margin-bottom: 2rem;
    }
}
</style>